import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';

export function initFaro(): void {
  const url = process.env.REACT_APP_FARO_URL;
  if (!url) return;

  initializeFaro({
    url,
    app: {
      name: 'prumo',
      version: '0.3.2',
      environment: process.env.NODE_ENV,
    },
    instrumentations: getWebInstrumentations({
      captureConsole: false, // console.log is too noisy for production shipping
    }),
    // Suppress browser noise and expected offline-PWA errors.
    ignoreErrors: ['ResizeObserver loop', 'Network Error', 'Failed to fetch', 'Load failed'],
  });
}
